<template>
    <layout-main>
        <head-title value="About Us" />
        <layout-content>
            <content-header>
                <top-nav>
                    <top-nav-back />
                    <top-nav-title>
                        About
                    </top-nav-title>
                </top-nav>
            </content-header>

            <content-body>
                <div class="p-4 flex flex-col gap-2">
                    <p>Corperland is a vibrant and inclusive forum platform designed to connect and empower National Youth Service Corps (NYSC) members across Nigeria. Our vision is to foster a sense of community, collaboration, and growth among NYSC members by providing a safe and engaging space for meaningful connections and knowledge-sharing.</p>
                    <p>With a mission to enhance the overall NYSC experience, Corperland focuses on increasing user engagement, improving user experience, expanding the user base, fostering collaboration, and providing relevant content tailored to the interests and needs of NYSC members.</p>
                    <p>Join us on Corperland to connect with fellow NYSC members, participate in discussions, explore interest groups, and access valuable resources to support your personal and professional development during your service year.</p>
                </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
